<template>
  <div>
    <Tabs :tabIndex="tabIndex"/>
    <div class="container">
      <Breadcrumb/>
      <div class="files files-mb">
        <b-navbar class="mypage__navbar">
          <b-collapse id="nav-collapse-admin" is-nav class="justify-content-between">
            <b-navbar-nav>
              <b-nav-item class="mypage__navlink pl-0"><span class="mypage__statistic">合計</span><span class="mypage__statistic__number mypage__statistic__number__green">{{metadata.total_items}}</span></b-nav-item>
              <b-nav-item class="mypage__navlink hidden-mb"><span class="mypage__statistic">フォルダ</span><span class="mypage__statistic__number mypage__statistic__number__yellow">{{metadata.total_folders}}</span></b-nav-item>
              <b-nav-item class="mypage__navlink hidden-mb"><span class="mypage__statistic">PDF</span><span class="mypage__statistic__number mypage__statistic__number__pink">{{metadata.total_pdfs}}</span></b-nav-item>
              <b-nav-item class="mypage__navlink hidden-mb"><span class="mypage__statistic">画像</span><span class="mypage__statistic__number mypage__statistic__number__blue">{{metadata.total_images}}</span></b-nav-item>
              <b-nav-item class="mypage__navlink hidden-mb"><span class="mypage__statistic">動画</span><span class="mypage__statistic__number mypage__statistic__number__purple">{{metadata.total_videos}}</span></b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="align-items-center">
              <button class="btn--filter mr-14 btn-search" @click="showModalSearch()">
                <svg id="Group_3" data-name="Group 3" xmlns="http://www.w3.org/2000/svg" width="20.15" height="20.165" viewBox="0 0 20.15 20.165">
                  <path id="Path_9" data-name="Path 9" d="M8.5,16.608a8.3,8.3,0,1,1,8.3-8.3A8.313,8.313,0,0,1,8.5,16.608Zm0-15.034A6.73,6.73,0,1,0,15.23,8.3,6.737,6.737,0,0,0,8.5,1.574ZM20.115,19.935a.787.787,0,0,0,0-1.113L16.593,15.3a.787.787,0,0,0-1.113,1.113L19,19.935a.787.787,0,0,0,1.113,0Z" transform="translate(-0.196 0)" fill="#748175"/>
                </svg>
              </button>
              <button class="btn--filter" @click="listFile" :class="{active: !popup}"><i class="icon-i-list"></i></button>
              <button class="btn--filter" :class="{active: popup}" @click="gridFile"><i class="icon-i-grid"></i></button>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <GridFiles :pageIndex="page_index" @changePageIndex="changePageIndex" v-if="popup" @pageIndexBack="pageIndexBack"/>
        <ListFiles :pageIndex="page_index" @changePageIndex="changePageIndex"  @sortName="sortName" @sortDate="sortDate" @pageIndexBack="pageIndexBack" v-else/>
      </div>
      <SearchFile />
    </div>
    <BtnGroupAdd v-if="showPopupAdd()" @pageIndexBack="pageIndexBack"/>
  </div>
</template>

<script>
import Tabs from '../../../components/Admin/Company/Tabs'
import ListFiles from '@/components/Admin/FolderManagerment/ListFiles'
import GridFiles from '@/components/Admin/FolderManagerment/GridFiles'
import SearchFile from '@/views/Admin/FolderManagement/SearchFile'
import Breadcrumb from '@/components/Admin/FolderManagerment/Breadcrumb'
import {mapState} from 'vuex'
import BtnGroupAdd from '@/components/Admin/FolderManagerment/BtnGroupAdd'
export default {
  name: 'List',
  data () {
    return {
      popup: false,
      modalShow: false,
      tabIndex: 3,
      page_index: 1,
      tags: [],
      media_type_ids: [],
      query: {
        tag: [],
        type: [],
        begin: '',
        end: '',
        folder: '',
        file: '',
        author: ''
      },
      date: '',
      name: ''
    }
  },
  components: {ListFiles, GridFiles, Tabs, SearchFile, Breadcrumb, BtnGroupAdd},
  watch: {
    '$route.query' (newVal) {
      if (newVal.tab === 'grid') {
        this.popup = true
      } else {
        this.popup = false
      }
      if (this.$route.params.folder_id === 'search' && (newVal.author !== this.query.author ||
        this.compareArray(newVal.tag.split(','), this.query.tag) || this.compareArray(newVal.type.split(','), this.query.type) ||
        this.query.file !== newVal.file || this.query.folder !== newVal.folder || this.query.begin !== newVal.begin || this.query.end !== newVal.end)) {
        this.page_index = 1
        this.query.tag = newVal.tag.split(',')
        this.query.type = newVal.type.split(',')
        this.query.folder = newVal.folder
        this.query.file = newVal.file
        this.query.author = newVal.author
        this.query.begin = newVal.begin
        this.query.end = newVal.end
        this.reloadFileAdmin(this.page_index)
      }
    },
    '$route.params.folder_id' (value) {
      this.page_index = 1
      this.reloadFileAdmin(this.page_index, this.name, this.date)
    }
  },
  methods: {
    showPopupAdd () {
      return this.$route.params.folder_id !== 'search'
    },
    pageIndexBack () {
      this.page_index = 1
    },
    sortName () {
      this.page_index = 1
      this.date = ''
      if (this.name === '' || this.name === 'ASC') {
        this.name = 'DESC'
        this.reloadFileAdmin(this.page_index, this.name)
      } else {
        this.name = 'ASC'
        this.reloadFileAdmin(this.page_index, this.name)
      }
    },
    sortDate () {
      this.name = ''
      this.page_index = 1
      if (this.date === '' || this.date === 'ASC') {
        this.date = 'DESC'
        this.reloadFileAdmin(this.page_index, '', this.date)
      } else {
        this.date = 'ASC'
        this.reloadFileAdmin(this.page_index, '', this.date)
      }
    },
    changePageIndex (pageIndex) {
      this.page_index = pageIndex
      this.reloadFileAdmin(this.page_index, this.name, this.date)
    },
    compareArray (value, value1) {
      if (value) {
        if (value.length !== value1.length) {
          return true
        } else {
          for (let i = 0; i < value.length; i++) {
            if (value[i] !== value1[i]) {
              return true
            }
          }
          return false
        }
      }
    },
    gridFile () {
      this.popup = true
      if (this.$route.params.folder_id === 'search') {
        this.$router.push({
          path: this.$route.path,
          query: {tab: 'grid', type: this.$route.query.type, begin: this.$route.query.begin, end: this.$route.query.end, folder: this.$route.query.folder, author: this.$route.query.author, tag: this.$route.query.tag, file: this.$route.query.file}
        })
      } else {
        this.$router.push({
          query: {tab: 'grid'}
        })
      }
    },
    listFile () {
      if (this.$route.params.folder_id === 'search') {
        this.$router.push({
          path: this.$route.path,
          query: {type: this.$route.query.type, begin: this.$route.query.begin, end: this.$route.query.end, folder: this.$route.query.folder, author: this.$route.query.author, tag: this.$route.query.tag, file: this.$route.query.file}
        })
      } else {
        this.$router.push({
          path: this.$route.path
        })
      }
      this.popup = false
    },
    showModalAddFiles () {
      this.$store.dispatch('adminFolder/getTag', {company_id: this.$route.params.id})
      this.$root.$emit('bv::show::modal', 'modalAddFiles', '#modalAddFiles')
    },
    showModalSearch () {
      this.$store.dispatch('adminFolder/getFolderMove', {id: 0, company_id: this.$route.params.id})
      this.$store.dispatch('adminFolder/getAuthor', {id: 0, page_index: 1, company_id: this.$route.params.id})
      this.$store.dispatch('adminFolder/getTag', {page_index: 1, company_id: this.$route.params.id})
      this.$root.$emit('bv::show::modal', 'modalUploadFile', '#modalUploadFile')
    }
  },
  computed: {
    ...mapState({
      metadata: state => state.adminFolder.metadata
    })
  },
  mounted () {
    if (this.$route.query.tab === 'grid') {
      this.popup = true
    } else {
      this.popup = false
    }
    const newVal = this.$route.query
    if (this.$route.params.folder_id === 'search') {
      this.query.tag = newVal.tag.split(',')
      this.query.type = newVal.type.split(',')
      this.query.folder = newVal.folder
      this.query.file = newVal.file
      this.query.author = newVal.author
      this.query.begin = newVal.begin
      this.query.end = newVal.end
    }
    this.reloadFileAdmin(this.page_index)
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
@import "@/assets/stylesheet/auth/listfile.scss";
</style>



// WEBPACK FOOTER //
// src/views/Admin/FolderManagement/List.vue